import { render, staticRenderFns } from "./FacilitySettingsTab.vue?vue&type=template&id=14521a4a&scoped=true"
import script from "./FacilitySettingsTab.vue?vue&type=script&lang=js"
export * from "./FacilitySettingsTab.vue?vue&type=script&lang=js"
import style0 from "./FacilitySettingsTab.vue?vue&type=style&index=0&id=14521a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14521a4a",
  null
  
)

export default component.exports